import { createContext, useContext } from 'react';
var HasTextAncestorContext = /*#__PURE__*/createContext(false);
/**
 * @internal
 */
export var useHasTextAncestor = function useHasTextAncestor() {
  return useContext(HasTextAncestorContext);
};
/**
 * @internal
 */
export var HasTextAncestorProvider = HasTextAncestorContext.Provider;